import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getAuthHeaders, api } from '../utils/api';

export const fetchUser = createAsyncThunk(
  'user/fetchUser',
  async (token, { rejectWithValue }) => {
    try {
      const res = await api.get('/users/me', {
        headers: getAuthHeaders(token),
      });
      // Return both data and HTTP status so reducers can set it
      return { data: res.data, status: res.status };
    } catch (err) {
      // Try to extract HTTP status if axios-like error
      const status = err?.response?.status ?? null;
      const message = err?.response?.data?.message ?? err?.message ?? 'Unknown error';
      return rejectWithValue({ message, status });
    }
  }
);

const initialState = {
  data: null,
  loading: false,
  error: null,        // string or null
  status: null,       // semantic status (e.g., 'ok'/'error') — optional
  httpStatus: null,   // numeric HTTP status code (e.g., 200, 403)
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.data = action.payload;
    },
    clearUser: (state) => {
      state.data = null;
      state.error = null;
      state.httpStatus = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUser.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.httpStatus = null;
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload?.data ?? null;
        state.httpStatus = action.payload?.status ?? null;
        state.status = 'ok';
        if (action.payload?.data) {
          localStorage.setItem('user', JSON.stringify(action.payload.data));
        }
      })
      .addCase(fetchUser.rejected, (state, action) => {
        state.loading = false;
        // action.payload comes from rejectWithValue
        state.error = action.payload?.message ?? action.error?.message ?? 'Failed to fetch user';
        state.httpStatus = action.payload?.status ?? null;
        state.status = 'error';
      });
  },
});

export const { setUser, clearUser } = userSlice.actions;
export default userSlice.reducer;
